import styled from '@emotion/styled'

export const FormFieldsWrapper = styled.div`
  position: relative;
`
